import React, { MouseEvent, ReactElement } from 'react';

import { noop } from '@philips-emr/tws-utils';

export interface InformationBarSecondaryRowProps {
  children: ReactElement | ReactElement[];
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}

function InformationBarSecondaryRow(props: InformationBarSecondaryRowProps): ReactElement | null {
  const { children, onClick = noop } = props;

  return (
    <div className="c-information-bar__row c-information-bar__row--secondary" onClick={onClick}>
      {children}
    </div>
  );
}

export default InformationBarSecondaryRow;
